import { render, staticRenderFns } from "./PostChallengeSuccess.vue?vue&type=template&id=9aff56aa&scoped=true"
import script from "./PostChallengeSuccess.vue?vue&type=script&lang=ts"
export * from "./PostChallengeSuccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aff56aa",
  null
  
)

export default component.exports